module.exports = __webpack_public_path__ + "static/media/nuevo_logo.a87fabea.gif";